import { l } from '@manychat/manyui'

import { ExternalTriggerType } from 'apps/externalTriggers/externalTriggerConstants'
import { IExternalTrigger } from 'apps/externalTriggers/externalTriggerInterfaces'
import { AppIdToIconMapping } from 'common/builder/components/builder/TriggerPicker/constants'
import {
  ConverterRule,
  TriggersConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import {
  FlowChartTrigger,
  FlowChartTriggerIconType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'
import { isTriggerInteractive } from 'common/builder/utils/isTriggerInteractive'
import { TriggerType } from 'common/flow/constants/TriggerType'
import { IFlowTrigger } from 'common/flow/flowInterfaces'
import { getTikTokAdsTriggerSubtitleByAppType } from 'utils/lib/getTikTokAdsTriggerSubtitleByAppType'

export const TikTokAdsGenericTriggerConverterRule: ConverterRule<
  IFlowTrigger,
  FlowChartTrigger,
  TriggersConverterRulePayload
> = {
  predicate: (entity: IFlowTrigger) =>
    entity?.triggerType === TriggerType.EXTERNAL_TRIGGER &&
    entity?.externalTriggerType === ExternalTriggerType.TIKTOK_ADS_CTX,
  convert: (entity: IExternalTrigger) => {
    const appType =
      entity.data && 'messaging_app_type' in entity.data ? entity.data.messaging_app_type : null
    const trigger: FlowChartTrigger = {
      id: entity.triggerId,
      icon: {
        type: FlowChartTriggerIconType.ICON,
        icon: AppIdToIconMapping[entity.appId],
      },
      title: l.translate('User replies on your TikTok Ad'),
      subtitle: [getTikTokAdsTriggerSubtitleByAppType(appType)],
      subtitleIcon: null,
      isActive: entity.enabled,
      isInteractive: isTriggerInteractive(entity),
    }

    return trigger
  },
}
